import { Pipe, PipeTransform } from '@angular/core'
import { baseColorCode, strongColorCode, surveyBackgroundColorCode, weakColorCode } from 'src/utils/utils'
import { MBTI } from '../interfaces/mbti'

@Pipe({
  name: 'mbtiColor',
})
export class MbtiColorPipe implements PipeTransform {
  transform(
    value: MBTI | 'ALL' | undefined,
    style: 'color' | 'background-color' | 'code' = 'color',
    type: 'base' | 'weak' | 'strong' | 'survey-background' = 'base'
  ): string {
    if (value) {
      if (style === 'code') {
        return `${this.colorCode(value, type)}`
      }
      return `${style}: ${this.colorCode(value, type)};`
    }
    return ''
  }

  colorCode(value: MBTI | 'ALL', type: 'base' | 'weak' | 'strong' | 'survey-background'): string {
    if (value === 'ALL') {
      return 'var(--grey-80)'
    }
    switch (type) {
      case 'base':
        return baseColorCode(value)
      case 'weak':
        return weakColorCode(value)
      case 'strong':
        return strongColorCode(value)
      case 'survey-background':
        return surveyBackgroundColorCode(value)
    }
  }
}
